import { gql } from '@apollo/client';

export const activatePerson = gql`
  mutation activatePerson($personId: String!) {
    salesforce {
      activatePerson(personId: $personId)
    }
  }
`;

export const deactivatePerson = gql`
  mutation deactivatePerson($personId: String!) {
    salesforce {
      deactivatePerson(personId: $personId)
    }
  }
`;

export const activatePersonAddress = gql`
  mutation activatePersonAddress(
    $personId: String!
    $personAddresses: [String!]!
  ) {
    salesforce {
      activatePersonAddress(
        personId: $personId
        personAddresses: $personAddresses
      )
    }
  }
`;

export const deactivatePersonAddress = gql`
  mutation deactivatePersonAddress(
    $personAddresses: [String!]!
    $personId: String!
  ) {
    salesforce {
      deactivatePersonAddress(
        personAddresses: $personAddresses
        personId: $personId
      )
    }
  }
`;

export const deletePersonPartner = gql`
  mutation deletePersonPartner($ids: [String!]!) {
    salesforce {
      deletePersonPartner(ids: $ids)
    }
  }
`;

export const deleteAuthorizedSignatory = gql`
  mutation deleteAuthorizedSignatory($ids: [String!]!) {
    salesforce {
      deleteAuthorizedSignatories(ids: $ids)
    }
  }
`;
